import React from 'react';
import Header from './Header';
import Footer from './Footer';
import WordpressPricingSection from './WordpressPricingSection';

export default function WordpressLandingPage() {
  return (
    <div className="bg-gradient-to-br from-gray-950 via-purple-950 to-gray-900 min-h-screen flex flex-col">
      <Header />
      {/* HERO */}
      <section className="pt-24 pb-16 md:pt-32 md:pb-24 text-center relative z-10">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl md:text-5xl font-extrabold text-white mb-4 drop-shadow-lg">
            Hospedagem WordPress Profissional
          </h1>
          <p className="text-lg md:text-2xl text-purple-200 max-w-2xl mx-auto mb-8">
            Performance, segurança e liberdade para seu site WordPress crescer sem limites. Instalação fácil, suporte especializado e recursos avançados para você focar no seu conteúdo.
          </p>
          <a href="#planos-wordpress" className="inline-block px-8 py-4 rounded-xl bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-bold text-lg shadow-lg hover:scale-105 transition-transform">
            Ver Planos WordPress
          </a>
        </div>
      </section>
      {/* BENEFÍCIOS WORDPRESS */}
      <section id="recursos-wordpress" className="py-12 md:py-20 bg-gradient-to-b from-gray-950/80 to-transparent">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center">
            Por que escolher nossa Hospedagem WordPress?
          </h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-gray-900/80 rounded-xl p-6 flex flex-col items-center text-center shadow-lg border border-purple-900">
              <span className="text-purple-400 mb-3">
                <svg width="32" height="32" fill="none" viewBox="0 0 24 24"><path d="M12 3v18m9-9H3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </span>
              <h3 className="text-lg font-bold text-white mb-2">Performance Máxima</h3>
              <p className="text-gray-300 text-sm">Servidores otimizados para WordPress, cache avançado e armazenamento NVMe ultrarrápido para seu site voar.</p>
            </div>
            <div className="bg-gray-900/80 rounded-xl p-6 flex flex-col items-center text-center shadow-lg border border-purple-900">
              <span className="text-purple-400 mb-3">
                <svg width="32" height="32" fill="none" viewBox="0 0 24 24"><path d="M12 20l9-5-9-5-9 5 9 5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </span>
              <h3 className="text-lg font-bold text-white mb-2">Segurança Reforçada</h3>
              <p className="text-gray-300 text-sm">Proteção contra ataques, backups automáticos, SSL grátis e monitoramento 24/7 para seu site sempre seguro.</p>
            </div>
            <div className="bg-gray-900/80 rounded-xl p-6 flex flex-col items-center text-center shadow-lg border border-purple-900">
              <span className="text-purple-400 mb-3">
                <svg width="32" height="32" fill="none" viewBox="0 0 24 24"><path d="M8 17l4 4 4-4m0-5V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v9m0 0l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </span>
              <h3 className="text-lg font-bold text-white mb-2">Liberdade Total</h3>
              <p className="text-gray-300 text-sm">Instale qualquer plugin ou tema, acesse FTP, banco de dados e tenha controle total do seu WordPress.</p>
            </div>
          </div>
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto mt-10">
            <div className="bg-gray-900/80 rounded-xl p-6 flex flex-col items-center text-center shadow-lg border border-purple-900">
              <span className="text-purple-400 mb-3">
                <svg width="32" height="32" fill="none" viewBox="0 0 24 24"><path d="M12 8v4l3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </span>
              <h3 className="text-lg font-bold text-white mb-2">Instalação Fácil</h3>
              <p className="text-gray-300 text-sm">WordPress pronto para usar em 1 clique. Comece seu site em minutos, sem complicação.</p>
            </div>
            <div className="bg-gray-900/80 rounded-xl p-6 flex flex-col items-center text-center shadow-lg border border-purple-900">
              <span className="text-purple-400 mb-3">
                <svg width="32" height="32" fill="none" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </span>
              <h3 className="text-lg font-bold text-white mb-2">Suporte Especializado</h3>
              <p className="text-gray-300 text-sm">Equipe pronta para ajudar com dúvidas, migração e otimização do seu WordPress, 24 horas por dia.</p>
            </div>
            <div className="bg-gray-900/80 rounded-xl p-6 flex flex-col items-center text-center shadow-lg border border-purple-900">
              <span className="text-purple-400 mb-3">
                <svg width="32" height="32" fill="none" viewBox="0 0 24 24"><path d="M12 8v4l3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </span>
              <h3 className="text-lg font-bold text-white mb-2">Escalabilidade</h3>
              <p className="text-gray-300 text-sm">Seu site pode crescer sem limites: recursos flexíveis para projetos pequenos ou grandes portais.</p>
            </div>
          </div>
        </div>
      </section>
      {/* PLANOS WORDPRESS */}
      <WordpressPricingSection />
      <Footer />
    </div>
  );
} 